export default __webpack_public_path__ + "static/media/pauseicon.50447575.svg";